var map = {
	"./KKR.png": "44bd",
	"./dataRoma.png": "f3ac",
	"./degiro-dark.png": "d035",
	"./degiro.png": "dec5",
	"./financial-times-screener-dark.png": "c943",
	"./financial-times-screener.png": "5a6b",
	"./finviz.png": "4dad",
	"./ibkr-dark.png": "b416",
	"./ibkr.png": "1c71",
	"./indexa.png": "4c6d",
	"./ing-dark.png": "d1e8",
	"./ing.png": "aea6",
	"./microcapsearch.png": "11d2",
	"./morningstar.png": "bb22",
	"./myinvestor-dark.png": "7728",
	"./myinvestor.png": "8474",
	"./renta4-dark.png": "7986",
	"./renta4.png": "3bb0",
	"./seeking-alpha-dark.png": "56d1",
	"./seeking-alpha.png": "465b",
	"./tikr-dark.png": "7904",
	"./tikr.png": "50e9",
	"./trading-view-dark.png": "c03f",
	"./trading-view.png": "9900"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d0d2";